import React from "react";
import ModuleAccess from "./ModuleAccess";
import { CardBody, Container, Row } from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { Card } from "react-bootstrap";

export default function index() {
  const breadcrumbItems = [
    { title: "Settings", link: "" },
    { title: "User Managment", link: "" },
    { title: "Module Access", link: "/settings/user_management/moduleaccess" },
  ];
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          {/* <Card className="details-wrapper"> */}
          {/* <CardBody> */}
            <ModuleAccess />
          {/* </CardBody> */}
          {/* </Card> */}
        </Container>
      </div>
    </React.Fragment>
  );
}
